<template>
  <b-container fluid>
    <iq-card>
      <template v-slot:headerTitle>
        <h4 class="
            card-title
            float-lefttitle-typography-color
            title-typography-color
          ">
          <i class="fas fa-wallet"></i>
          {{ $t("public.views.Pages.Professional.Event.event") }}
        </h4>
      </template>
      <template v-slot:headerAction></template>
      <template v-slot:body>
        <b-row>
          <b-col>
            <b-form-group label-for="professionalModalCita">
              <template slot="label">{{
                $t("public.views.Pages.Professional.Event.professional")
              }}:
              </template>
              <ul class="list-group">
                <li v-if="event.professionalLead" class="list-group-item">
                  <b-avatar v-if="event.professionalLead.avatar" class="mr-2" v-bind:src="
                    event.professionalLead.avatarUrl
                      ? event.professionalLead.avatarUrl +
                      '/' +
                      getAuthentication()
                      : ''
                  "></b-avatar>
                  <b-avatar v-else class="mr-2"></b-avatar>
                  {{ event.professionalLead.name }}
                  {{ event.professionalLead.lastname }} ({{
                    event.professionalLead.phone
                  }})
                  <b-badge class="text-uppercase" pill variant="primary">{{
                    $t("public.views.Pages.Professional.Event.leader")
                  }}
                  </b-badge>
                </li>
              </ul>
            </b-form-group>
          </b-col>
        </b-row>
        <b-row>
          <b-col>
            <b-form-group label-for="patientModalCita">
              <template v-if="event.billings && event.billings.length !== 0" slot="label">{{
                $t("public.views.Pages.Professional.Event.contacts")
              }}:
              </template>
              <ul class="list-group">
                <li v-for="(item, index) in event.billings" :key="index" :item="item" class="list-group-item">
                  <div v-if="item.patient">
                    <b-avatar class="mr-2" v-bind:src="
                      item.patient.avatarUrl
                        ? item.patient.avatarUrl +
                        '/' +
                        getAuthentication()
                        : ''
                    "></b-avatar>
                    {{ item.patient.name }} {{ item.patient.lastname }} ({{
                      item.patient.phone
                    }})
                    <b-badge v-if="
                      item.payment &&
                      item.payment.paymentMode !== 'OUT_PLATAFORM'
                    " class="mr-2 text-uppercase" variant="success">{{
  $t("public.views.Pages.Professional.Event.paid")
}}
                    </b-badge>
                    <b-badge v-if="
                      item.payment &&
                      item.payment.paymentMode === 'OUT_PLATAFORM' &&
                      item.payment.paymentOutPlataform
                    " class="mr-2 text-uppercase" variant="success">{{
  $t("public.views.Pages.Professional.Event.paid")
}}
                      ({{ item.payment.paymentOutPlataform.name }})
                    </b-badge>
                    <b-badge v-if="!item.payment" class="mr-2 text-uppercase" variant="danger">{{
                      $t("public.views.Pages.Professional.Event.unpaid")
                    }}
                    </b-badge>

                    <b-row>
                      <b-col class="text-center">
                        <v-btn v-b-toggle="'more-info-patient-' + item.patient.id" class="ma-2 mr-2" color="indigo"
                          outlined rounded x-small>
                          {{
                            $t("public.views.Pages.Professional.Event.moreInfo")
                          }}
                        </v-btn>
                        <b-collapse :id="'more-info-patient-' + item.patient.id">
                          <b-card-body>
                            <b-card-text>
                              <ul>
                                <li v-if="item.paymentPlace === 'WALLET'">
                                  <span class="ml-2 font-weight-bold">{{
                                    $t(
                                                                      "public.views.Pages.Professional.Event.payMode"
                                    )
                                  }}:
                                  </span>
                                  {{
                                    $t(
                                                                    "public.views.Pages.Professional.Event.wallet"
                                    )
                                  }}
                                </li>
                                <li v-if="item.paymentPlace === 'OUT_PLATAFORM'">
                                  <span class="ml-2 font-weight-bold">{{
                                    $t(
                                                                      "public.views.Pages.Professional.Event.payMode"
                                    )
                                  }}: </span>{{
  $t(
                                  "public.views.Pages.Professional.Event.payNeednt"
  )
}}
                                </li>
                                <li v-if="
                                  item.paymentPlace === 'BEFORE_EVENT_ONLINE'
                                ">
                                  <span class="ml-2 font-weight-bold">{{
                                    $t(
                                                                      "public.views.Pages.Professional.Event.payMode"
                                    )
                                  }}: </span>{{
  $t(
                                  "public.views.Pages.Professional.Event.payBefore"
  )
}}
                                </li>
                                <li v-if="
                                  item.paymentPlace === 'AFTER_EVENT_ONLINE'
                                ">
                                  <span class="ml-2 font-weight-bold">{{
                                    $t(
                                                                      "public.views.Pages.Professional.Event.payMode"
                                    )
                                  }}: </span>{{
  $t(
                                  "public.views.Pages.Professional.Event.payAfter"
  )
}}
                                </li>
                                <!------->
                                <li v-if="item.price">
                                  <span class="ml-2 font-weight-bold">{{
                                    $t(
                                                                      "public.views.Pages.Professional.Event.sessionPrice"
                                    )
                                  }}: </span>{{ item.price }} €
                                </li>
                              </ul>
                            </b-card-text>
                          </b-card-body>
                        </b-collapse>
                      </b-col>
                    </b-row>
                  </div>
                </li>
              </ul>
            </b-form-group>
          </b-col>
        </b-row>
        <b-row v-if="event.startedAt">
          <b-col>
            <b-form-group label-for="startedAt">
              <template slot="label">{{
                $t("public.views.Pages.Professional.Event.start")
              }}:
              </template>
              <ul class="list-group">
                <li class="list-group-item">
                  {{ event.startedAt }}
                </li>
              </ul>
            </b-form-group>
          </b-col>
        </b-row>
        <b-row v-if="event.deletedAt">
          <b-col>
            <b-form-group label-for="deletedAt">
              <template slot="label">Acabo:</template>
              <ul class="list-group">
                <li class="list-group-item">
                  {{ event.deletedAt }}
                </li>
              </ul>
            </b-form-group>
          </b-col>
        </b-row>
        <b-row v-if="event.eventPlace">
          <b-col>
            <b-form-group label-for="eventPlace">
              <template slot="label">{{
                $t("public.views.Pages.Professional.Event.eventPlace")
              }}:
              </template>
              <ul class="list-group">
                <li class="list-group-item">
                  <b-badge v-if="event.eventPlace === 'ONLINE'" variant="success">
                    {{ $t("public.views.Pages.Professional.Event.online") }}
                  </b-badge>
                  <b-badge v-if="event.eventPlace === 'OFFLINE'" variant="success">
                    {{ $t("public.views.Pages.Professional.Event.offline") }}
                  </b-badge>
                </li>
              </ul>
            </b-form-group>
          </b-col>
        </b-row>
        <b-row v-if="event.extraTime">
          <b-col>
            <b-form-group label-for="eventPlace">
              <template slot="label">Tiempo extra:</template>
              <ul class="list-group">
                <li class="list-group-item">
                  {{ event.extraTime }}
                  {{ $t("public.views.Pages.Professional.Event.mins") }}.
                </li>
              </ul>
            </b-form-group>
          </b-col>
        </b-row>

        <b-row v-if="event.recording">
          <b-col>
            <b-form-group label-for="eventPlace">
              <template slot="label">{{
                $t("public.views.Pages.Professional.Event.recorded")
              }}:
              </template>
              <ul class="list-group">
                <li class="list-group-item">
                  <b-badge v-if="event.recording" variant="success">
                    {{ $t("public.views.Pages.Professional.Event.yes") }}
                  </b-badge>
                  <b-badge v-else variant="danger">
                    {{ $t("public.views.Pages.Professional.Event.no") }}
                  </b-badge>
                </li>
              </ul>
            </b-form-group>
          </b-col>
        </b-row>
        <b-row v-if="event.reference">
          <b-col>
            <b-form-group label-for="eventPlace">
              <template slot="label">{{
                $t("public.views.Pages.Professional.Event.reference")
              }}:
              </template>
              <ul class="list-group">
                <li class="list-group-item">
                  {{ event.reference }}
                </li>
              </ul>
            </b-form-group>
          </b-col>
        </b-row>
        <b-row>
          <b-col>
            <b-form-group label-for="eventPlace">
              <template slot="label">{{
                $t("public.views.Pages.Professional.Event.emailReminder")
              }}:
              </template>
              <ul class="list-group">
                <li class="list-group-item">
                  <b-badge v-if="event.remainderEmail" variant="success">
                    {{ $t("public.views.Pages.Professional.Event.yes") }}
                  </b-badge>
                  <b-badge v-else variant="danger">
                    {{ $t("public.views.Pages.Professional.Event.no") }}
                  </b-badge>
                </li>
              </ul>
            </b-form-group>
          </b-col>

          <b-col>
            <b-form-group label-for="eventPlace">
              <template slot="label">{{
                $t("public.views.Pages.Professional.Event.phoneReminder")
              }}:
              </template>
              <ul class="list-group">
                <li class="list-group-item">
                  <b-badge v-if="event.remainderPhone" variant="success">
                    {{ $t("public.views.Pages.Professional.Event.yes") }}
                  </b-badge>
                  <b-badge v-else variant="danger">
                    {{ $t("public.views.Pages.Professional.Event.no") }}
                  </b-badge>
                </li>
              </ul>
            </b-form-group>
          </b-col>

          <b-col>
            <b-form-group label-for="eventPlace">
              <template slot="label">{{
                $t("public.views.Pages.Professional.Event.smsReminder")
              }}:
              </template>
              <ul class="list-group">
                <li class="list-group-item">
                  <b-badge v-if="event.remainderSms" variant="success">
                    {{ $t("public.views.Pages.Professional.Event.yes") }}
                  </b-badge>
                  <b-badge v-else variant="danger">
                    {{ $t("public.views.Pages.Professional.Event.no") }}
                  </b-badge>
                </li>
              </ul>
            </b-form-group>
          </b-col>
          <b-col>
            <b-form-group label-for="eventPlace">
              <template slot="label">{{
                $t("public.views.Pages.Professional.Event.whatsReminder")
              }}:
              </template>
              <ul class="list-group">
                <li class="list-group-item">
                  <b-badge v-if="event.remainderWhatapp" variant="success">
                    {{ $t("public.views.Pages.Professional.Event.yes") }}
                  </b-badge>
                  <b-badge v-else variant="danger">
                    {{ $t("public.views.Pages.Professional.Event.no") }}
                  </b-badge>
                </li>
              </ul>
            </b-form-group>
          </b-col>
        </b-row>
        <b-row v-if="event.visitType">
          <b-col>
            <b-form-group label-for="tipoModalCita">
              <template slot="label">{{
                $t("public.views.Pages.Professional.Event.visitType")
              }}:
              </template>

              <ul class="list-group">
                <li class="list-group-item">
                  <i :style="'color: ' + event.visitType.colour" class="fas fa-circle mr-2"></i>
                  {{ event.visitType.name }}
                </li>
              </ul>
            </b-form-group>
          </b-col>
        </b-row>
        <b-row v-if="event.visitType">
          <b-col>
            <ul class="list-group">
              <li class="list-group-item">
                <b-badge v-if="event.visitType.onlineType === 'MONOCOFERENCE'" variant="primary">
                  {{ $t("public.views.Pages.Professional.Event.monoVideo") }}
                </b-badge>
                <b-badge v-if="event.visitType.onlineType === 'MULTICONFERENCE'" variant="primary">
                  {{ $t("public.views.Pages.Professional.Event.multiVideo") }}
                </b-badge>
              </li>
            </ul>
          </b-col>
        </b-row>
      </template>
    </iq-card>
    <notifications group="notificacions" />
  </b-container>
</template>
<script>
import routes from "../../../router/index";

import { mapActions, mapGetters } from "vuex";

import { xray } from "../../../config/pluginInit";
import { StripeCheckout } from "@vue-stripe/vue-stripe";
import validator from "vue-m-validator";

import walletService from "../../../services/wallet";
import utilsService from "../../../services/utils";
import userService from "../../../services/user";
import patientService from "../../../services/patient";
import scheduleService from "../../../services/schedule";

export default {
  name: "WalletProfessional",
  mounted() {
    xray.index();
    this.getUser();
    this.getEvent();
    utilsService.auditActivity({ action: "VIEW", module: "PROFESSIONAL_EVENT", info: "" });
  },
  methods: {
    getAuthentication() {
      return localStorage.getItem('authorization');
    },
    backContacts() {
      this.$router.push({
        name: "auth.professional.contact.contacts",
      });
    },
    //Check if patient is in paths
    checkSelectPatient(patients) {
      let self = this;
      if (this.$route.query.patient) {
        patients.forEach(function (item) {
          if (item.id == self.$route.query.patient) {
            self.showWalletTransaction(
              item.walletId,
              item.id,
              item.walletBalance
            );
          }
        });
        self.getPatient(this.$route.query.patient);
      }
    },
    // Get event
    async getEvent() {
      let self = this;

      this.$awn.asyncBlock(
        scheduleService.getEvent(this.eventId),
        (response) => {
          if (response) {
            self.event = response.data;
          }
        },
        (error) => {
          utilsService.auditErrorFrontent({
            info: "scheduleService.getEvent",
            module: "view-pages-professional-event",
            httpStatus: error.response ? error.response.status : null,
            endpoint: window.location.href,
            request: JSON.stringify({
              eventId: this.eventId
            })
          });
        },
        " "
      );
    },
    showWalletTransaction(walletId, patientId, walletBalance) {
      this.searchPatient = false;
      this.walletId = walletId;
      this.walletBalance = walletBalance;
      this.patientId = patientId;
      this.getAllWalletTransactions(walletId);
    },
    // Modal validator
    checkCharge(_charge) {
      const CHARGE = _charge.trim();
      const RULE_1 = {
        expression: !CHARGE || CHARGE === "",
        name: "name",
        msg: this.$i18n.t(
          "public.auth.professional.wallet.modalCharge.errors.charge"
        ),
      };
      const RULE_2 = {
        expression: CHARGE === "0",
        name: "name",
        msg: this.$i18n.t(
          "auth.professional.wallet.modalCharge.errors.chargeEqualsZero"
        ),
      };
      validator.addRule(RULE_1).addRule(RULE_2);
      this.notFirst();
    },
    notFirst() {
      this.isFirstRun = false;
    },
    checkFormCharge() {
      this.checkCharge(this.charge);
    },
    // List
    async getUser() {
      let self = this;
      userService
        .get(localStorage.getItem("userId"))
        .then((response) => {
          if (response) {
            self.user = response.data;
          }
        })
        .catch(function (error) {
          if (error.response && error.response.status === 404) {
            routes.push({ name: "public.signin" });
          } else if (error.response && error.response.status === 500) {
            routes.push({ name: "public.signin" });
          } else {
            routes.push({ name: "public.signin" });
          }
        });
    },
    getAllWalletTransactions(id) {
      let self = this;

      this.$awn.asyncBlock(
        walletService.getAllTransactions(0, 10000, id),
        (response) => {
          if (response) {
            self.walletTransactions = response.data;
          }
        },
        (error) => {
          utilsService.auditErrorFrontent({
            info: "walletService.getAllTransactions",
            module: "view-pages-professional-dashboard",
            httpStatus: error.response ? error.response.status : null,
            endpoint: window.location.href,
            request: JSON.stringify({
              id: id
            })
          });
        },
        " "
      );
    },
    // Charge
    openModalCharge() {
      this.action = "CHARGE";
      this.$bvModal.show("modal-charge");
    },
    openModalDischarge() {
      this.action = "DISCHARGE";
      this.$bvModal.show("modal-charge");
    },
    payCash() {
      let self = this;

      let value = 1;

      if (this.action === "DISCHARGE") {
        value = -1;
      }

      let data = {
        charge: value * this.charge,
        patientId: this.patientId,
        comments: this.comments,
      };

      this.$awn.asyncBlock(
        walletService.payCash(this.walletId, data),
        (response) => {
          utilsService.auditActivity({ action: "UPDATE", module: "PROFESSIONAL_EVENT", info: "" });
          self.getAllWalletTransactions(self.walletId);
          this.$notify({
            group: "notificacions",
            title: this.$i18n.t(
              "public.views.Pages.Professional.Event.notification.title"
            ),
            text: this.$i18n.t(
              "public.views.Pages.Professional.Event.notification.descCharged"
            ),
            type: "success",
          });
        },
        (error) => {
          utilsService.auditErrorFrontent({
            info: "walletService.payCash",
            module: "view-pages-professional-dashboard",
            httpStatus: error.response ? error.response.status : null,
            endpoint: window.location.href,
            request: JSON.stringify({
              walletId: this.walletId
            })
          });
        },
        " "
      );
    },
    getPatient(id) {
      let self = this;

      this.$awn.asyncBlock(
        patientService.get(id),
        (response) => {
          if (response) {
            self.patient = response.data;
          }
        },
        (error) => {
          utilsService.auditErrorFrontent({
            info: "patientService.get",
            module: "view-pages-professional-dashboard",
            httpStatus: error.response ? error.response.status : null,
            endpoint: window.location.href,
            request: JSON.stringify({
              id: id
            })
          });
        }
      );
    },
  },
  computed: {
    //Validate form
    isDisabled() {
      return this.isFirstRun === true || this.validator.errors.length > 0;
    },
    isFormChargeErrors() {
      let errors = this.validator.getErrors("charge");
      return errors && errors.length > 0;
    },
    ...mapGetters({
      selectedUser: "Setting/userState",
    }),
  },
  data() {
    return {
      action: "",
      //Global
      eventId: this.$route.query.eventId,
      event: {},
      user: {},
      validator: validator,
      isFirstRun: true,
      isValidate: false,
      searchPatient: true,
      //Modal charge
      walletId: "",
      charge: "1",
      comments: "",
      professionalId: "",
      walletBalance: "",
      //Table transactions

      headers: [
        {
          text: this.$i18n.t(
            "public.views.Pages.Professional.Event.headers.date"
          ),
          align: "start",
          value: "date",
        },
        {
          text: this.$i18n.t(
            "public.views.Pages.Professional.Event.headers.spend"
          ),
          value: "spend",
        },
        {
          text: this.$i18n.t(
            "public.views.Pages.Professional.Event.headers.type"
          ),
          value: "type",
        },
        {
          text: this.$i18n.t(
            "public.views.Pages.Professional.Event.headers.payment"
          ),
          value: "payment",
        },
        {
          text: this.$i18n.t(
            "public.views.Pages.Professional.Event.headers.professional"
          ),
          value: "professional",
        },
        {
          text: this.$i18n.t(
            "public.views.Pages.Professional.Event.headers.cashFlow"
          ),
          value: "cashFlow",
        },
        {
          text: "",
          value: "actions",
        },
      ],
      walletTransactions: [],
      //Table patients
      headersPatients: [
        {
          text: this.$i18n.t(
            "public.views.Pages.Professional.Event.headers.name"
          ),
          align: "start",
          value: "name",
        },
        {
          text: this.$i18n.t(
            "public.views.Pages.Professional.Event.headers.lastname"
          ),
          value: "lastname",
        },
        {
          text: this.$i18n.t(
            "public.views.Pages.Professional.Event.headers.phone"
          ),
          value: "phone",
        },
        {
          text: this.$i18n.t(
            "public.views.Pages.Professional.Event.headers.document"
          ),
          value: "document",
        },
        {
          text: this.$i18n.t(
            "public.views.Pages.Professional.Event.headers.email"
          ),
          value: "email",
        },
        {
          text: this.$i18n.t(
            "public.views.Pages.Professional.Event.headers.walletBalance"
          ),
          value: "walletBalance",
        },
        {
          text: this.$i18n.t(
            "public.views.Pages.Professional.Event.headers.actions"
          ),
          value: "actions",
        },
      ],
      patients: [],
      patient: {},
    };
  },
  components: {
    StripeCheckout,
  },
};
</script>
